<template>
  <v-container style="margin-top: 10%">
    <v-row align="start" justify="center">
      <v-col cols="12">
        <v-card class="mx-auto" max-width="500">
          <v-layout justify-center>
            <v-img
              align="center"
              justify="center"
              class="mt-8 mb-3"
              aspect-ratio="6"
              :transition="false"
              contain
              :src="
                require(`@/assets/${this.$store.getters.getLogo.path}/logo.png`)
              "
            />
          </v-layout>
          <v-layout justify-center>
            <v-card-title class="title font-weight-regular mb-2">{{
              $t("general.noPermission.youDoNotHavePermissionToAccessThisPage")
            }}</v-card-title>
          </v-layout>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    setTimeout(() => {
      this.$router.push({ name: "login" });
    }, 4000);
  },
};
</script>
